import { Caption } from "@components/Typography";
import { useTheme } from "@hooks";
import { CSSProperties } from "react";
import styled from "styled-components";

export const Footer = styled(Caption)`
  align-self: center;
  font-size: 0.75em;
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    footer: {
      color: theme.footer.secondary,
    },
    successMessage: {
      color: theme.promo.valid.default,
    },
  };

  return styles;
};
